<template>
  <div class="bottom_tree_table">
    <div class="bottom_left">
      <major-tree @detailBtn="detailBtn"></major-tree>
    </div>
    <div class="bottom_right">
      <div class="right_button" style="display: inline-block">
        <el-button v-if="addLayer" type="primary" size="small" plain @click="addStandard">
          增加
        </el-button>
        <el-button v-if="deleLayer" :disabled="!layerId" type="primary" size="small" plain @click="deleteStandard">
          删除
        </el-button>
        <el-button v-if="editLayer" :disabled="!layerId" type="primary" size="small" plain @click="updateStandard">
          修改
        </el-button>
        <el-button v-if="addLayer" type="primary" plain size="small" :disabled="!majorID" @click="upLoadFile">
          导入
        </el-button>
      </div>
      <div class="right_table">
        <el-table :data="personTable" border highlight-current-row style="height: 100%" height="100%" @row-click="handleChange">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              暂无数据
            </p>
          </template>
          <el-table-column label="图层名" prop="layerName" min-width="200px" />
          <el-table-column label="线型" prop="lineType" min-width="120px" />
          <el-table-column label="线宽" prop="lineWeight" min-width="80px" />
          <el-table-column label="颜色" prop="colour" min-width="50px" />
          <el-table-column label="打印样式" prop="plotStyle" min-width="150px" />
          <el-table-column label="是否锁定" min-width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isLocked" :true-label="1" :false-label="0" disabled />
            </template>
          </el-table-column>
          <el-table-column label="是否冻结" min-width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isFrozen" :true-label="1" :false-label="0" disabled />
            </template>
          </el-table-column>
          <el-table-column label="是否关闭" min-width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isOff" :true-label="1" :false-label="0" disabled />
            </template>
          </el-table-column>
          <el-table-column label="是否打印" min-width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isPrint" :true-label="1" :false-label="0" disabled />
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remark" min-width="180px" />
        </el-table>
      </div>
      <page :page="page" class="page-2" @handleSizeChange="handleSizeChange" @handleCurrentChange="fetchData"></page>
    </div>
    <!-- 添加图层 -->
    <el-dialog v-dialogDrag :title="standardTitle" :visible.sync="standardDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      :modal-append-to-body="false" :before-close="getReset" width="600px">
      <el-form ref="standardForm" size="small" :model="standardForm" :rules="rules" class="demo-form-inline" label-width="100px">
        <el-form-item label="所属图层组" prop="layerType">
          <el-select v-model="standardForm.layerType" style="width: 100%" clearable filterable size="small">
            <el-option v-for="(item, specId) in majorList" :key="specId" :value="item.specName" :label="item.specName">
              {{ item.specName }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图层名" prop="layerName">
          <el-input v-model="standardForm.layerName" maxlength="100" show-word-limit clearable size="small" />
        </el-form-item>
        <el-form-item label="颜色">
          <el-input-number v-model="standardForm.colour" :min="1" :max="255" style="width: 100%" size="small"></el-input-number>
        </el-form-item>
        <el-form-item label="线宽" prop="lineWeight">
          <el-select v-model="standardForm.lineWeight" style="width: 100%" clearable filterable size="small">
            <el-option v-for="(item, id) in lineWeightList" :key="id" :value="item.lineWeight" :label="item.lineWeight">
              {{ item.lineWeight }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="线型" prop="lineType">
          <el-select v-model="standardForm.lineType" style="width: 100%" clearable filterable size="small">
            <el-option v-for="(item, id) in linearList" :key="id" :value="item.lineType" :label="item.lineType">
              {{ item.lineType }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打印样式" prop="plotStyle">
          <el-input v-model="standardForm.plotStyle" maxlength="100" show-word-limit clearable size="small" />
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="standardForm.isLocked" :true-label="1" :false-label="0" label="是否锁定" />
          <el-checkbox v-model="standardForm.isFrozen" :true-label="1" :false-label="0" label="是否冻结" />
          <el-checkbox v-model="standardForm.isOff" :true-label="1" :false-label="0" label="是否关闭" />
          <el-checkbox v-model="standardForm.isPrint" :true-label="1" :false-label="0" label="是否打印" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="standardForm.remark" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea"
            maxlength="200" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="getReset">取 消</el-button>
        <el-button v-if="submitType == 0" type="primary" size="small" @click="addStandardBtn">确 定</el-button>
        <el-button v-if="submitType == 1" type="primary" size="small" @click="updateStandardBtn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量导入 -->
    <batchImport ref="batchImport" :dialog-drag-title="dialogDragTitle" :need-type="needType" @downTemplate="downTemplate"
      @suredaoru="suredaoru" @getList="getList" @getfreshen="getfreshen"></batchImport>
  </div>
</template>
<script>
import standardLayer from "@/CommonDP/service/standardLayer-service";
import majorTree from "@/CommonDP/components/structure/majorTree.vue";
import standardTemplateService from "@/CommonDP/service/standardTemplate-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
import page from "@/CommonDP/components/paging";
import { downloadFile, downStandardLayerTemplate } from "@/CommonDP/utils";
import batchImport from "@/CommonDP/components/batchImport";
const newEmptyStandardForm = () => ({
  layerType: "",
  layerName: "",
  colour: "",
  lineWeight: "",
  lineType: "",
  plotStyle: "",
  isLocked: 0,
  isFrozen: 0,
  isOff: 0,
  isPrint: 0,
  remark: ""
});
export default {
  name: "StandardLayer",
  components: { page, majorTree, batchImport },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      specName: "",
      rules: {
        layerType: [{ required: true, message: "请选择图层组名称", trigger: "change" }],
        layerName: [{ required: true, message: "请输入图层名", trigger: "blur" }],
        lineWeight: [{ required: true, message: "请选择线宽", trigger: "change" }],
        lineType: [{ required: true, message: "请选择线型", trigger: "change" }],
        plotStyle: [{ required: true, message: "请输入打印样式", trigger: "blur" }]
      },
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      standardForm: newEmptyStandardForm(),
      standardDialog: false,
      personTable: [],
      tuijianIcon: require("@/CommonDP/assets/doc/folder_icon.png"),
      submitType: "",
      majorID: undefined,
      layerId: undefined,
      majorList: [],
      lineWeightList: [],
      linearList: [],
      addLayer: checkPermission(this.$allPerms.STANDARLAYER_ADD),
      deleLayer: checkPermission(this.$allPerms.STANDARLAYER_DALE),
      editLayer: checkPermission(this.$allPerms.STANDARLAYER_EDIT),
      dialogDragTitle: '导入',
      needType: 3
    };
  },
  computed: {
    standardTitle() {
      return ["添加标准图层", "修改标准图层"][this.submitType];
    },
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    submitForm() {
      const {
        submitType,
        enterpriseId,
        standardForm: {
          layerType,
          layerName,
          colour,
          lineWeight,
          lineType,
          plotStyle,
          isLocked,
          isFrozen,
          isOff,
          isPrint,
          remark
        }
      } = this;
      const layerTypeCode = this.majorList.find(item => item.specName === layerType)?.specId;

      const params = {
        layerTypeCode,
        layerType,
        layerName,
        colour,
        lineWeight,
        lineType,
        plotStyle,
        isLocked,
        isFrozen,
        isOff,
        isPrint,
        remark,
        layerId: this.layerId,
        enterpriseId
      };
      if (submitType === 0) delete params.layerId;
      return params;
    }
  },

  methods: {
    upLoadFile() {
      const a = disablePrompt();
      if (a) {
        this.$refs.batchImport.batchImportDialogVisible = true;
      }
    },
    getfreshen() {
      this.categories(this.majorID, 1); // 刷新列表
    },
    // 下载模板
    downTemplate() {
      console.log('下载模板');
      const downzipurl = downStandardLayerTemplate();
      downloadFile(downzipurl);
    },
    suredaoru(fileLis) {
      this.$refs.batchImport.disabledone = true;
      const data = new FormData();
      data.append("file", fileLis);
      data.append("enterpriseId", this.enterpriseId);
      data.append("layerTypeCode", this.majorID);
      standardLayer.uploadStandardLayerImport(data)
        .then((res1) => {
          this.$refs.batchImport.commonSuredaoru(res1);
        })
        .catch(() => {
          this.$refs.batchImport.disabledone = false;
        });
    },
    async getList(failList) {
      standardLayer.standardLayerExportFailList(failList)
        .then((response) => {
          this.$refs.batchImport.commonGetList(response);
        });
    },
    // 获取专业
    async getMajor() {
      const { data } = await standardTemplateService.getSpecListStandard(this.enterpriseId);
      this.majorList = data;
    },
    getlineWeight() {
      standardLayer.standardLayerLineWeight().then(({ data }) => {
        this.lineWeightList = data;
      });
    },
    async getlinear() {
      const { data } = await standardLayer.standardLayerGetlinear(this.enterpriseId);
      this.linearList = data;
    },
    detailBtn(val) {
      this.specName = val.specName;
      this.majorID = val.specId;
      this.categories(val.specId, 1);
    },
    fetchData(val) {
      this.categories(this.majorID, val);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.categories(this.majorID, 1);
    },
    // 获取图层
    async categories(item, index) {
      this.layerId = undefined;
      const params = {
        dicCode: item,
        pageNum: index,
        pageSize: this.page.pageSize,
        enterpriseId: this.enterpriseId
      };
      const res = await standardLayer.categoriesList(params);
      this.personTable = res.data || [];
      this.page.pageNum = res.pageNum;
      this.page.totalCount = res.totalCount;
    },
    handleChange(row) {
      console.log(row);
      this.layerId = row.layerId;
    },
    addStandard() {
      const a = disablePrompt();
      if (a) {
        this.standardDialog = true;
        this.submitType = 0;
        this.getMajor();
        this.getlineWeight();
        this.getlinear();
        this.$nextTick(function () {
          this.$refs.standardForm.clearValidate();
        });
        this.standardForm = newEmptyStandardForm();
        this.standardForm.layerType = this.specName;
      }
    },
    updateStandard() {
      const a = disablePrompt();
      if (a) {
        this.standardDialog = true;
        this.submitType = 1;
        this.layerDetail(this.layerId);
      }
    },
    layerDetail(val) {
      standardLayer.standardLayerDetail(val).then(({ data }) => {
        this.standardForm = data[0];
        this.getMajor();
        this.getlineWeight();
        this.getlinear();
      });
    },
    // 添加图层
    addStandardBtn() {
      const { submitForm: params } = this;
      this.$refs.standardForm.validate((valid) => {
        if (valid) {
          standardLayer.standardLayerAddcategories(params).then((data) => {
            if (data.result === "0") {
              this.$message.success("添加成功");
            } else {
              this.$message.warning("添加失败");
            }
            this.categories(this.majorID, 1);
            this.getReset();
          });
        } else {
          return false;
        }
      });
    },
    // 修改后
    updateStandardBtn() {
      const { submitForm: params } = this;
      this.$refs.standardForm.validate((valid) => {
        if (valid) {
          standardLayer.standardLayerUpdate(params).then((data) => {
            if (data.result === "0") {
              this.$message.success("修改成功");
            } else {
              this.$message.warning("修改失败");
            }
            this.categories(this.majorID, 1);
            this.getReset();
          });
        } else {
          return false;
        }
      });
    },
    // 删除
    async deleteStandard() {
      const a = disablePrompt();
      if (a) {
        await this.$confirm("此操作将删除本行数据，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        await standardLayer.standardLayer_delete(this.layerId);
        this.$message.success("删除成功");
        this.categories(this.majorID, 1); // 刷新列表
      }
    },
    // 清空表单
    getReset() {
      this.$refs.standardForm.resetFields();
      this.standardDialog = false;
    }
  }
};
</script>
<style lang="scss" scoped>
$top-button-height: 42px;
$middle-height: 30px;
$left-width: 256px;
.bottom_tree_table {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .bottom_left {
    position: absolute;
    top: 10px;
    bottom: 0;
    left: 10px;
    width: $left-width;
    border-right: 1px solid #ebefff;
    .left_tree {
      overflow: auto;
      position: absolute;
      left: 0;
      top: 10px;
      bottom: 10px;
      right: 0;
      li {
        display: flex;
        border-bottom: 0;
        align-items: center;
        padding: 2px 30px;
        cursor: pointer;
        font-size: 14px;
        line-height: 26px;
        color: var(--key-color);
        img {
          margin-right: 8px;
        }
      }
    }
    .active {
      background: rgba(85, 132, 255, 0.1);
    }
  }
  .bottom_right {
    position: relative;
    height: 100%;
    margin-left: $left-width + 20px;
    display: flex;
    flex-direction: column;
    .right_button {
      padding: var(--middle-space) var(--big-space);
    }
    .right_table {
      padding: 0 var(--big-space);
      height: 1px;
      flex-grow: 1;
    }
  }
}
.page-2 {
  padding: var(--middle-space) var(--big-space);
  text-align: right;
}

/deep/.el-tree-node__content {
  height: 31px;
  line-height: 31px;
}
/deep/.el-divider--horizontal {
  margin: 10px 0;
}
</style>
